import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';
import moment from 'moment';

import { EventsFirestoreResponse, EventsPaginationData } from '../types';
import { EVENTS_PER_PAGE } from '../variables';
import { fetchDocumentsFromCollectionByFilter } from './utils';

const PAGE_SIZE = EVENTS_PER_PAGE;

export const useGetEventsFromFirestore = (
  page: number,
  id: string,
  options?: UseQueryOptions<EventsPaginationData, FirebaseError, EventsPaginationData>,
): UseQueryResult<EventsPaginationData, FirebaseError> => useQuery<EventsPaginationData,
    FirebaseError,
    EventsPaginationData
>({
  queryKey: [`hotels/${id}/events`, page, PAGE_SIZE] as const,
  queryFn: async (): Promise<EventsPaginationData> => {
    const today = moment().startOf('day').format('YYYY-MM-DD');
    const data = await fetchDocumentsFromCollectionByFilter<EventsFirestoreResponse>(
      `hotels/${id}/events`,
      'eventDate',
      '>=',
      today,
    );
    const mappedData = data.map((item) => ({
      id: item.id,
      title: item.title,
      isOpen: item.isOpen,
      date: item.date,
      localization: item.localization,
      time: item.time,
      timeTo: item.timeTo,
      coverPhoto: item.coverPhoto,
      eventDate: item.eventDate,
      eventTimeFrom: item.eventTimeFrom,
      eventTimeTo: item.eventTimeTo,
      isInternalEvent: item.isInternalEvent,
      remainingEntries: item.remainingEntries,
      registration: item.registration,
      createdAt: item.createdAt,
    }));
    return { data: mappedData };
  },
  retry: 0,
  ...options,
});
